import { useCallback } from 'react';
import type { SmartSharpenValue } from '../../lib/filters/smart-sharpen';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Smart Sharpen panel — Unsharp Mask controls plus the halo
 *  suppression slider that's unique to this filter. The visual
 *  difference vs USM is most apparent on saturated colored edges
 *  (no chromatic fringing) and high-contrast edges (halo
 *  suppression clips overshoot). */
export function SmartSharpenPanel({ value, onChange }: AdjustmentPanelProps<SmartSharpenValue>) {
  const set = useCallback(
    (patch: Partial<SmartSharpenValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Amount"
        min={0}
        max={500}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
      <RangeRow
        label="Radius"
        min={0}
        max={50}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
      <RangeRow
        label="Threshold"
        min={0}
        max={255}
        step={1}
        value={value.threshold}
        onChange={(v) => set({ threshold: v })}
      />
      <RangeRow
        label="Reduce Halo"
        min={0}
        max={100}
        step={1}
        value={value.haloSuppression}
        onChange={(v) => set({ haloSuppression: v })}
      />
    </div>
  );
}
